import React from 'react';
import { Helmet } from 'react-helmet-async';

const landscapePilotImages = [
  'pilot_467217913_10225084495876679_3081053524358135933_n.jpg',
  'pilot_494108372_10226494220038902_8977833480102400170_n_1.jpg',
  'pilot_498214792_10226700278990247_8878729818623212849_n.jpg',
  'pilot_499202319_10226710650449527_5927934365128542534_n.jpg',
  'pilot_499455867_10226710655409651_6402864260029142045_n.jpg',
  'pilot_499545032_10226710652129569_605880555038474061_n.jpg',
  'pilot_499681971_10226710652169570_7721602662728124788_n.jpg',
  'pilot_500060591_10226812846204357_1328629778001213301_n.jpg',
  'pilot_503462933_10226885063009732_733205611964464566_n.jpg',
  'pilot_503605907_10226885060089659_5411030910545795905_n.jpg',
  'pilot_503996530_10226897640004149_3266274623818115446_n.jpg',
  'pilot_504090018_10226897639404134_4719526103349424943_n.jpg',
  'pilot_504880594_10226927108700848_3011650029849325866_n.jpg',
  'pilot_506113488_10227010119856075_5664350788947200544_n.jpg',
  'pilot_506168102_10226988393752936_5476502972030530250_n.jpg',
  'pilot_507183350_10242052449227450_5222883722564794041_n.jpg',
];

const portraitPilotImages = [
  'pilot_503171077_10226895605673292_9147578471790761127_n.jpg',
  'pilot_503742955_10226918747891833_2054264779380533000_n.jpg',
  'pilot_506232460_10226988393432928_1908105307870787685_n.jpg',
  'pilot_506432569_10227010118696046_7763655567585034985_n.jpg',
];

const squarePilotImages = [
  'pilot_506102093_10227010117296011_2209775131778671349_n.jpg',
  'pilot_506394369_10227010119816074_5660229023016508834_n.jpg',
];

const PrivatePilot = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Ariel Rotem | Private Pilot & Aviation</title>
        <meta name="description" content="Ariel Rotem is a private pilot. View aviation adventures, flight logs, and aerial photography from flights around the world." />
      </Helmet>
      <div className="mb-4">
        <h1 className="glitch" style={{ color: 'var(--accent-secondary)', fontSize: '2.5rem' }}>$ cat private_pilot.flight</h1>
      </div>

      <div className="terminal-card">
        <h3 className="mb-2" style={{ color: 'var(--accent-primary)', borderBottom: '1px dashed var(--text-secondary)', paddingBottom: '10px' }}>
          &gt; FLIGHT_LOG :: INIT
        </h3>
        <p className="mono">
          My fascination with aviation began at the tender age of seven. That moment ignited a passion that lay dormant for years, waiting for the right time (and funding!) to reignite. Quickly after earning my pilot license, I navigated to and landed at the lowest airport on Earth—an exhilarating experience performing patterns below sea level.
        </p>
        <p className="mono mt-1">
          Aviation demands profound knowledge, absolute precision, and continuous learning. It is an art form. I merge this passion with engineering by engaging in projects like software-defined airband radios, and with photography by capturing breathtaking aerial views.
        </p>
      </div>

      <div className="terminal-card mt-4">
        <h3 className="mb-2" style={{ color: 'var(--accent-secondary)' }}>&gt; VISUAL_DATA :: PULL</h3>
        <p className="mono text-secondary mb-2" style={{ fontSize: '0.85rem' }}>
          Parsing aerial imagery arrays...
        </p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
          {landscapePilotImages.map((img, idx) => (
            <img key={`l_${idx}`} src={`/PhotosForWebsite/${img}`} alt="Ariel Rotem flying an airplane as a private pilot" style={{ width: '100%', aspectRatio: '4/3', objectFit: 'cover', border: '1px solid var(--text-secondary)' }} />
          ))}
          {portraitPilotImages.map((img, idx) => (
            <img key={`p_${idx}`} src={`/PhotosForWebsite/${img}`} alt="Ariel Rotem in the cockpit, private pilot" style={{ width: '100%', aspectRatio: '3/4', objectFit: 'cover', border: '1px solid var(--text-secondary)' }} />
          ))}
          {squarePilotImages.map((img, idx) => (
            <img key={`s_${idx}`} src={`/PhotosForWebsite/${img}`} alt="Ariel Rotem aerial flight view" style={{ width: '100%', aspectRatio: '1/1', objectFit: 'cover', border: '1px solid var(--text-secondary)' }} />
          ))}
        </div>
      </div>

    </div>
  );
};

export default PrivatePilot;